var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 44.5417L42.1667 40.3189L39 31.875L35.8333 40.3189L34.25 44.5417M42.1667 40.3189H35.8333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.379 25.7634C36.2989 24.9796 36.7597 24.587 37.241 24.3574C37.7904 24.0953 38.3914 23.9592 39.0001 23.9592C39.6088 23.9592 40.2098 24.0953 40.7592 24.3574C41.2405 24.587 41.7013 24.9796 42.6212 25.7634C43.5696 26.5709 44.5323 26.9794 45.7989 27.0791C47.0039 27.1757 47.6071 27.2248 48.1106 27.4021C49.2728 27.8138 50.1879 28.7274 50.598 29.8911C50.7754 30.393 50.8244 30.9963 50.921 32.2028C51.0208 33.4695 51.4277 34.4305 52.2352 35.379C53.0205 36.2989 53.4132 36.7596 53.6428 37.241C54.1748 38.354 54.1748 39.6476 53.6428 40.7591C53.4132 41.2405 53.0205 41.7012 52.2368 42.6211C51.4521 43.5015 50.9884 44.6215 50.921 45.7989C50.8244 47.0038 50.7754 47.607 50.598 48.1105C50.3947 48.6844 50.0657 49.2056 49.6351 49.636C49.2044 50.0664 48.683 50.395 48.109 50.598C47.6071 50.7753 47.0039 50.8244 45.7974 50.921C44.5307 51.0207 43.5696 51.4276 42.6212 52.2351C41.7013 53.0205 41.2405 53.4131 40.7592 53.6427C40.2098 53.9048 39.6088 54.0409 39.0001 54.0409C38.3914 54.0409 37.7904 53.9048 37.241 53.6427C36.7597 53.4131 36.2989 53.0205 35.379 52.2367C34.4986 51.4521 33.3787 50.9884 32.2013 50.921C30.9964 50.8244 30.3931 50.7753 29.8896 50.598C29.3157 50.3947 28.7945 50.0657 28.3642 49.635C27.9338 49.2044 27.6051 48.683 27.4022 48.109C27.2249 47.607 27.1758 47.0038 27.0792 45.7973C27.0119 44.6207 26.5488 43.5013 25.765 42.6211C24.9797 41.7012 24.587 41.2405 24.3559 40.7591C24.094 40.2096 23.9582 39.6086 23.9585 38.9999C23.9588 38.3912 24.0951 37.7902 24.3574 37.241C24.587 36.7596 24.9797 36.2989 25.7634 35.379C26.5868 34.4115 26.981 33.4425 27.0792 32.2012C27.1758 30.9963 27.2249 30.393 27.4022 29.8895C27.6055 29.3157 27.9345 28.7945 28.3651 28.3641C28.7958 27.9337 29.3172 27.6051 29.8912 27.4021C30.3931 27.2248 30.9964 27.1757 32.2029 27.0791C33.3795 27.0118 34.4988 26.5471 35.379 25.7634Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalidad);
export default __webpack_public_path__ + "static/media/ic_calidad.129526f89d635d2f1e3c488df8039d7a.svg";
export { ForwardRef as ReactComponent };